<form class="new-exchange-rate-dialog" [formGroup]="newExchangeRateFG">
    <h2>Nuevo tipo de cambio</h2>
    <span>Esto creará un nuevo tipo de cambio para ser usado</span>

    <div class="form-line">
        <mat-form-field class="garantor-form-field" appearance="outline">
            <mat-label>Código moneda base</mat-label>
            <mat-select formControlName="codigoMonedaBase" [compareWith]="compare">
                <mat-option *ngFor="let currency of currencies" [value]="currency.codigo">
                    {{ currency.codigo }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="newExchangeRateFG.controls.codigoMonedaBase.hasError('required')">
                Este campo es requerido
            </mat-error>
        </mat-form-field>
    </div>

    <div class="form-line">
        <mat-form-field class="garantor-form-field" appearance="outline">
            <mat-label>Código moneda cambio</mat-label>
            <mat-select formControlName="codigoMonedaCambio" [compareWith]="compare">
                <mat-option *ngFor="let currency of currencies" [value]="currency.codigo">
                    {{ currency.codigo }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="newExchangeRateFG.controls.codigoMonedaCambio.hasError('required')">
                Este campo es requerido
            </mat-error>
        </mat-form-field>
    </div>

    <div class="form-line">
        <mat-form-field class="garantor-form-field" appearance="outline">
            <mat-label>Fecha y hora actual</mat-label>
            <input matInput formControlName="fecha" [matDatepicker]="picker1" >
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="newExchangeRateFG.controls.fecha.hasError('required')">
                Este campo es requerido
            </mat-error>
        </mat-form-field>
    </div>

    <div class="form-line">
        <mat-form-field class="garantor-form-field" appearance="outline">
            <mat-label>Tipo cambio</mat-label>
            <input matInput formControlName="cambio">
            <mat-error *ngIf="newExchangeRateFG.controls.cambio.hasError('required')">
                Este campo es requerido
            </mat-error>
        </mat-form-field>
    </div>

    <div class="buttons">
        <button mat-button color="accent" class="garantor-button mini" type="button" (click)="cancel()">Cancelar</button>
        <button mat-raised-button color="primary" class="garantor-button mini" (click)="createExchangeRate()">Crear</button>
    </div>
</form>
